import styled from "styled-components";
import { Scrollable, panelSpacing } from "../../../../../common/styles";

export const ProgramConnectionsContainer = styled.div`
    height: calc(100vh - 145px);
`;
export const ConnectionSection = styled.div`
    padding: 40px;
    border-radius: 10px;
    background: #FFF;
    margin: 0 10px;
    box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
    height: calc(100vh - 225px);
    ${Scrollable}
`;
export const ConnectionsHeading = styled.div`
    font-size: 24px;
`;
export const ConnectionsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
    @media (max-width: 1880px) {
        gap: 17px;
    }
`;
export const Span = styled.span`
    font-size:18px;
    font-weight:bold;
    text-align:center;
    padding-inline:20px  
`;